var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-user",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5248",
    "data-name": "Path 5248",
    d: "M11,10A5,5,0,1,0,6,5a5,5,0,0,0,5,5Zm0-8.333A3.333,3.333,0,1,1,7.667,5,3.333,3.333,0,0,1,11,1.667Z",
    transform: "translate(-0.5)",
    fill: "#BBC6D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M10.5,14A7.508,7.508,0,0,0,3,21.5a.833.833,0,1,0,1.667,0,5.833,5.833,0,1,1,11.667,0A.833.833,0,0,0,18,21.5,7.508,7.508,0,0,0,10.5,14Z",
    transform: "translate(0 -2.333)",
    fill: "#BBC6D1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrUser);
export default __webpack_public_path__ + "static/media/fi-rr-user.01e99f1b.svg";
export { ForwardRef as ReactComponent };